import { cn } from "@/utils";
import { Loader } from "@/components";

export const PageLoader = ({
  className,
  large,
}: {
  className?: string;
  large?: boolean;
}) => {
  return (
    <div
      className={cn(
        className,
        "relative flex h-full w-full items-center justify-center",
      )}
    >
      <Loader
        className={cn(
          "text-item-secondary absolute top-[calc(50%-1rem)]",
          large ? "h-12 w-12" : "h-8 w-8",
        )}
      />
    </div>
  );
};
